import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatActionTypes {
  IncomingMessage = 'chat/incomingMessage',
  SetEditableMessage = 'chat/setEditableMessage',
  DisableSendDefaultMessage = 'chat/disableSendDefaultMessage',
  Close = 'chatWindow/close',
  SetBubbleInputFocus = 'chatWindow/setBubbleInputFocus',
  Reset = 'chatWindow/reset',
}

export type TEditableMessagePayload = {
  chatId: string;
  text: string;
};

export type TDisableSendDefaultMessagePayload = {
  chatId: string;
};

export type TBubbleInputFocusPayload = {
  isBubbleInputFocused: boolean;
};

export type TChatActions =
  | ITypedReduxAction<EChatActionTypes.IncomingMessage, TMessageSchema>
  | ITypedReduxAction<EChatActionTypes.SetEditableMessage, TEditableMessagePayload>
  | ITypedReduxAction<EChatActionTypes.DisableSendDefaultMessage, TDisableSendDefaultMessagePayload>
  | ITypedReduxAction<EChatActionTypes.Close>
  | ITypedReduxAction<EChatActionTypes.Reset>
  | ITypedReduxAction<EChatActionTypes.SetBubbleInputFocus, TBubbleInputFocusPayload>;
